/**
 * Schema of ResponsavelConfigWhatsapp
 * @author gabrielbgil
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import ResponsavelConfigWhatsapp from '@/model/resource/ResponsavelConfigWhatsapp'

export default (model: ResponsavelConfigWhatsapp): Schema => ({
  responsavel: {
    content: model.responsavel && model.responsavel.$id,
    input: InputType.SELECT,
  },

  status: {
    content: model.status && model.status.$id,
    input: InputType.SELECT,
    meta: {
      required: true,
    },
  },

  ocorrencia: {
    content: model.ocorrencia && model.ocorrencia.$id,
    input: InputType.SELECT,
  },

  idConfigWhatsappPk: {
    content: model.idConfigWhatsappPk,
    editable: false,
  },

  mensagem: {
    content: model.mensagem,
    input: InputType.TEXTAREA,
    meta: {
      required: true,
      maxlength: '2000',
      rows: '2',
    },
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: true,
    input: InputType.CHECKBOX,
  },
})
